import { Block, PrensaEngine, Typography } from '@xprog/prensa'
import Link from 'next/link'
import React from 'react'
// import MoreButton from 'components/Buttons/MoreButton/MoreButton.index'
import { PrensaEngineColorType } from '@xprog/prensa/types'

type SectionMoreProps = {
  isDesktop?: boolean
  titleColor: PrensaEngineColorType
  titleDesktop: boolean
  titleMobile: boolean
  titleTarget: boolean
  titleLink: string
  titleLabel: string
  titleIcon: string
}

const LinkStyled = PrensaEngine.styled('a', {
  align: ['row', 'left', 'middle'],
  cursor: 'pointer',
  width: 'fit-content'
})

const SectionMore: React.FC<SectionMoreProps> = ({
  isDesktop,
  titleColor,
  titleDesktop,
  titleMobile,
  titleTarget,
  titleLink,
  titleLabel,
  titleIcon
}) => {
  const responsiveClass: Array<string> = []

  if (!titleMobile && !isDesktop) return null

  if (titleMobile && titleDesktop) {
    if (isDesktop) {
      return null
    }
  } else {
    !isDesktop && titleMobile && responsiveClass.push('mobile')
    isDesktop && titleDesktop && responsiveClass.push('desktop')
  }

  const LinkWrap: React.FC<any> = ({ children }) => {
    if (!titleLink || titleLink == '') return children
    const props = titleTarget ? { target: '_blank ' } : {}
    return (
      <Link {...props} href={titleLink}>
        <LinkStyled>{children}</LinkStyled>
      </Link>
    )
  }
  return (
    <Block
      className={`Item ${responsiveClass.join(' ')}`}
      css={{
        align: ['row', 'right', 'middle'],
        mb: '$4',
        ml: '$4',
        width: '100%',
        'svg path': { fill: `$${titleColor}` }
      }}
    >
      <LinkWrap>
        {/* <MoreButton borderColor={titleColor} fontColor={titleColor} value={titleLabel} /> */}
      </LinkWrap>
    </Block>
  )
}

export default SectionMore
